import "@/components/Portal/components/PortalDeviceTiles/PortalDeviceTiles.scss";

import { FC } from "react";

import { PortalDeviceList } from "@/components/Portal/components/PortalDeviceList/PortalDeviceList";
import { portalRoutes } from "@/router/routes/portalRoutes";

import { MySubscriptionsLayout } from "./MySubscriptionsLayout";

/**
 * MySubscriptionsList component displays a list of SIM cards in a table format.
 * It provides features like filtering and pagination, specifically for the
 * My Subscriptions page.
 *
 * @returns {JSX.Element} The rendered MySubscriptionsList component.
 */
export const MySubscriptionsList: FC = () => (
  <MySubscriptionsLayout>
    <PortalDeviceList manageRoute={portalRoutes.manageDevice.base} />
  </MySubscriptionsLayout>
);
